import { downloadAttachment } from 'api/v2/shared/downloadDocument';
import getDocumentURI from 'api/v2/shared/getDocumentURI';

const downloadFileFromPath = async (
  filePath: string,
  customName?: string | undefined,
): Promise<void> => {
  await getDocumentURI(filePath).then(({ url }) =>
    downloadAttachment(
      url,
      customName || (filePath.split('/').pop() as string),
    ),
  );
};

export default downloadFileFromPath;
